import { API_TYPES, WorkerRequirementDomain } from "@clipboard-health/contract-worker-app-bff";
import { Card, CbhIcon, Text } from "@clipboard-health/ui-components";
// eslint-disable-next-line no-restricted-imports
import { CardActionArea, CardContent, Chip, Stack } from "@mui/material";
import { APP_V2_APP_EVENTS, logEvent } from "@src/appV2/lib/analytics";
import { mergeWorkerRequirementWithIncludedResources } from "@src/appV2/redesign/Documents/api/mergeWorkerRequirementWithIncludedResources";
import {
  requirementRelationship,
  useGetWorkerRequirements,
} from "@src/appV2/redesign/Documents/api/useGetWorkerRequirements";
import { DOCUMENT_DETAILS_FULL_PATH } from "@src/appV2/redesign/Documents/paths";
import { useGetWorkerLicensesAllowedForDocuments } from "@src/appV2/redesign/Documents/useGetWorkerLicensesAllowedForDocuments";
import { generatePath, useHistory } from "react-router-dom";

import {
  getDocumentRequirement,
  OnboardingRequirementStatuses,
} from "../../hooks/useOnboardingRequirement";
import { getChipProps } from "./getChipProps";

// FIXME: Do not hardcode requirement IDs. Rely on existing APIs to perform these actions
export const RESUME_REQUIREMENT_ID = "5b93302a38aeaa0014c36899";

export function ResumeCard() {
  const history = useHistory();

  const { licenses: availableLicenses } = useGetWorkerLicensesAllowedForDocuments();

  const { data: workerRequirementData, isSuccess } = useGetWorkerRequirements(
    {
      filter: {
        qualifications: availableLicenses,
        domains: [WorkerRequirementDomain.HIRING, WorkerRequirementDomain.FLEX],
        "requirement.id": [RESUME_REQUIREMENT_ID],
      },
      include: [
        ...requirementRelationship,
        API_TYPES.requirementMappings,
        API_TYPES.workerDocuments,
      ],
    },
    {
      select: mergeWorkerRequirementWithIncludedResources,
    }
  );
  const { status: resumeStatus } = getDocumentRequirement(
    workerRequirementData ?? [],
    RESUME_REQUIREMENT_ID
  );
  const resumeChipProps = getChipProps(resumeStatus);

  return isSuccess ? (
    <Card variant="tertiary">
      <CardActionArea
        onClick={() => {
          logEvent(APP_V2_APP_EVENTS.PLACEMENT_ONBOARDING_PAGE_ACTIONS, {
            action: "resume-clicked",
            resumeStatus,
          });

          history.push(
            generatePath(DOCUMENT_DETAILS_FULL_PATH, {
              requirementId: RESUME_REQUIREMENT_ID,
            })
          );
        }}
      >
        <CardContent>
          <Stack direction="row" spacing={3}>
            <CbhIcon type="document" />
            <Stack spacing={3} flex={1}>
              <Stack direction="row" justifyContent="space-between">
                <Text variant="h5">Resume</Text>
                {resumeChipProps ? <Chip {...resumeChipProps} /> : undefined}
              </Stack>
              {resumeStatus === OnboardingRequirementStatuses.REJECTED ||
              resumeStatus === OnboardingRequirementStatuses.MISSING ? (
                <Text variant="body2" sx={{ color: (theme) => theme.palette.text.secondary }}>
                  Upload your resume
                </Text>
              ) : undefined}
            </Stack>
          </Stack>
        </CardContent>
      </CardActionArea>
    </Card>
  ) : null;
}
